import { Component } from '@angular/core';
import { PROFILE, THEME_PROFILE } from '../../../helpers/globals';

@Component({
    selector: 'app-branding',
    templateUrl: './branding.component.html',
    styleUrls: ['./branding.component.css']
})
export class BrandingComponent {
    profile = PROFILE;
    THEME_PROFILE = THEME_PROFILE;

    getStyle(){
        const hostname = window.location.hostname;
        if(hostname.includes('localhost')){
            return `#15803d !important`;
        }
        if(hostname.includes('staging')){
            return '#fbbf24 !important';
        }
        if(hostname.includes('sandbox')){
            return '#f43f5e !important';
        }
        return '';
    }
}
